import { render, staticRenderFns } from "./BudgetPOList.vue?vue&type=template&id=63a64150&"
import script from "./BudgetPOList.vue?vue&type=script&lang=js&"
export * from "./BudgetPOList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports